import React, { useState } from 'react';
import { Package } from 'lucide-react';
import { Product } from '../../../../../types';

interface ProductCardProps {
  product: Product;
  onAdd: (oddsWeight: number) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, onAdd }) => {
  const [oddsWeight, setOddsWeight] = useState(product.weight);

  const stockTone =
    product.stock > 10 ? 'text-musgo'
      : product.stock > 0 ? 'text-mostarda-dark'
        : 'text-bordo';

  return (
    <div className="bg-white border border-tinta/10 rounded-lg p-4 hover:border-tinta/20 hover:shadow-sm transition-all">
      <div className="flex items-start gap-3">
        {product.image_url ? (
          <img
            src={product.image_url}
            alt={product.name}
            className="w-12 h-12 rounded-lg object-cover flex-shrink-0 border border-tinta/10"
          />
        ) : (
          <div className="w-12 h-12 bg-creme-light border border-tinta/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Package size={20} className="text-tinta-soft/60" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-bold text-tinta truncate leading-tight">{product.name}</h4>
          <p className="text-xs mb-3">
            <span className="text-tinta-soft">Estoque: </span>
            <span className={`font-bold ${stockTone}`}>{product.stock}</span>
          </p>

          <div className="flex items-center gap-2">
            <label className="text-xs font-bold uppercase tracking-wider text-tinta">Peso:</label>
            <input
              type="number"
              min="1"
              value={oddsWeight}
              onChange={(e) => setOddsWeight(parseInt(e.target.value) || 1)}
              className="w-16 bg-white border border-tinta/15 rounded-lg px-2 py-1 text-xs text-tinta focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo"
            />
            <button
              onClick={() => onAdd(oddsWeight)}
              disabled={product.stock === 0}
              className="px-3 py-1.5 text-xs font-bold text-bordo bg-bordo/8 border border-bordo/20 rounded-md hover:bg-bordo/15 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Adicionar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
